import { FaDongSign, FaDollarSign, FaBahtSign } from 'react-icons/fa6';
import { FaCoins } from 'react-icons/fa';

// Map a currency code to its own currency-sign icon (VND ₫ / USD $ / THB ฿).
export const CURRENCY_ICON = {
  VND: FaDongSign,
  USD: FaDollarSign,
  THB: FaBahtSign,
};

export const currencyIcon = (code) => CURRENCY_ICON[code] || FaCoins;

export default currencyIcon;
